module.exports = __webpack_public_path__ + "img/step3-sc.b6b31828.png";